<template>
  <div>
    <px-view-header title="Minha empresa" :breadcrumbs="breadcrumbs"/>
    <px-premium-banner/>
    <v-card
      class="mx-auto mt-3"
    >
      <v-card-text v-if="loading">
        <px-circular-loading/>
      </v-card-text>
      <v-card-text v-if="!loading">
        <p class="headline mb-1 text--primary">
          {{ empresa.pessoa.nome }}
          <px-show-avaliacao-icon-simple class="ml-2"
                                         :avaliacao="entidade.pontuacaoMediaFrete"/>
          <px-show-premium class="ml-3"/>
        </p>
        <p>
          <v-icon>mdi-domain</v-icon>
          {{ empresa.pessoa.cnpj | cnpj }}
        </p>
        <div class="text--primary">
          <v-icon>mdi-map-marker</v-icon>
          {{ empresa.endereco | endereco }}
        </div>
      </v-card-text>
    </v-card>
    <px-minha-empresa-tabs v-if="empresa" class="mt-3" :empresa="empresa"/>
  </div>
</template>

<script>
import EntidadeService from '@/api/entidade-service';
import TransportadoraService from '@/api/transportador-service';
import MinhaEmpresaTabs from './MinhaEmpresaTabs.vue';
import PxShowPremium from './PxShowPremium.vue';

export default {
  data() {
    return {
      loading: false,
      empresa: null,
      entidade: null,
      breadcrumbs: [
        { text: 'Empresa' },
        { text: 'Minha empresa' },
      ],
    };
  },
  created() {
    this.loading = true;
    TransportadoraService.get()
      .then((response) => {
        [this.empresa] = response.data;
        return EntidadeService.getEntidade()
          .then(({ data }) => {
            this.entidade = data;
          });
      })
      .finally(() => {
        this.loading = false;
      });
  },
  components: {
    pxMinhaEmpresaTabs: MinhaEmpresaTabs,
    PxShowPremium,
  },
};
</script>
